import React, { useState } from 'react';
import './ChatWidget.css';

const ChatWidget = () => {
  const [isOpen, setIsOpen] = useState(false);

  // 🔴 REPLACE THIS WITH YOUR HUGGING FACE SPACE URL
  // Example: "https://your-username-kagwe-ai.hf.space"
  const BOT_URL = "https://samzeus-kagwe-ai.hf.space"; 

  return (
    <div className="chat-widget-wrapper">
      {/* The Chat Window (Hidden until clicked) */}
      <div className={`chat-iframe-container ${isOpen ? 'open' : ''}`}>
        <div className="chat-header">
          <span>⚖️ Kagwe & Co Assistant</span>
          <button onClick={() => setIsOpen(false)}>×</button>
        </div>
        {isOpen && (
          <iframe 
            src={BOT_URL} 
            title="Chat Bot"
            width="100%" 
            height="100%" 
            frameBorder="0"
          ></iframe>
        )}
      </div>

      {/* The Floating Button */}
      <button 
        className="chat-toggle-button" 
        onClick={() => setIsOpen(!isOpen)}
      >
        {isOpen ? 'Close' : '💬 Chat'}
      </button>
    </div>
  );
};

export default ChatWidget;